import Vue from 'vue'
/**
 * 格式化价格 对其使用自定义字体number-blod
 * @example
 * 1999.99 => ￥1999.99
 */
function format(el, binding) {
  const { value, oldValue } = binding
  if(value === oldValue || isNaN(Number(value))) return
  const [int, decimal] = value.toString().split('.')
  const decimalEl = decimal ? `<i>.${decimal}</i>` : ''
  el.innerHTML = `<span class="g-format--price"><i>￥</i>${int}${decimalEl}</span>`
}
Vue.directive('price', {
  bind: format,
  update: format
})